import { render, staticRenderFns } from "./line-play.vue?vue&type=template&id=fa54e050&"
import script from "./line-play.vue?vue&type=script&lang=js&"
export * from "./line-play.vue?vue&type=script&lang=js&"
import style0 from "./line-play.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports